<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
  @if (post() === undefined) {
    <div class="min-h-screen flex items-center justify-center text-white/70">Loading…</div>
  } @else if (post() === null) {
    <div class="min-h-screen flex flex-col items-center justify-center gap-4 text-white">
      <h1 class="text-3xl">Post not found</h1>
      <a routerLink="/blog" class="underline">Back to blog</a>
    </div>
  } @else {
    @let p = post()!;
    <article class="max-w-[820px] mx-auto px-6 pt-32 pb-20 text-white">
      <a routerLink="/blog" class="text-xs text-white/60 hover:text-white">&larr; All posts</a>

      <header class="mt-6 mb-10">
        <h1 class="font-outfit text-3xl md:text-5xl leading-tight">{{ p.title }}</h1>
        <div class="mt-4 text-sm text-white/60 flex flex-wrap gap-4">
          <span>{{ formattedDate() }}</span>
          <span>by {{ p.author }}</span>
          @for (c of p.category_names; track c) {
            <span class="px-2 py-0.5 bg-white/10 rounded text-xs">{{ c }}</span>
          }
        </div>
      </header>

      @if (p.featured_image) {
        <img [src]="p.featured_image"
             [alt]="p.featured_image_alt || p.title"
             class="w-full rounded-2xl mb-10 object-cover max-h-[480px]" />
      }

      <div class="prose prose-invert prose-lg max-w-none blog-content"
           [innerHTML]="sanitizedHtml()"></div>
    </article>
  }

  <app-connect></app-connect>
</app-background>
